/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { UsageTrendStore } from '../stores';

export const UsageTrendContext = createContext<UsageTrendStore>({} as UsageTrendStore);
